<hdi-breadcrumbs [breadcrumbs]="breadcrumbs"></hdi-breadcrumbs>

<!-- Newsticker Section -->
<ng-container *ngIf="newsticker">
  <hdi-section
    [paddingBottom]="true"
    [paddingBlock]="false"
    [paddingTop]="true"
  >
    <hdi-newsticker [caasData]="newsticker"></hdi-newsticker>
  </hdi-section>
</ng-container>

<!-- Alert Section -->
<ng-container *ngIf="alert">
  <hdi-section [paddingBottom]="true" [paddingBlock]="false">
    <hdi-alert [caasData]="alert"></hdi-alert>
  </hdi-section>
</ng-container>

<!-- Error 404 Section -->
<ng-container *ngIf="error404">
  <hdi-not-found-box [caasData]="error404"></hdi-not-found-box>
</ng-container>

<!-- Layouts -->
<ng-container *ngIf="caasData">
  <hdi-section
    *ngIf="buehne"
    [paddingBlock]="alert || newsticker ? false : !paddingBlock"
    [paddingBottom]="alert || newsticker ? true : paddingBottom"
  >
    <hdi-header-stage [caasData]="buehne" [attr.data-preview-id]="buehne?.identifier"></hdi-header-stage>
  </hdi-section>

  <!-- Welcome Section -->
  <hdi-section
    *ngIf="welcome"
    [paddingBottom]="alert || newsticker ? true : paddingBottom"
    [paddingBlock]="alert || newsticker ? false : !paddingBlock"
    [attr.data-preview-id]="welcome?.identifier"
  >
    <hdi-text-block
      [titleVariant]="TextBlockTitleVariant.H2"
      [titleContent]="welcomeContent?.header"
      [paragraph]="welcomeContent?.body"
      [paragraphAlign]="TextBlockAlign.CENTER"
      [titleAlign]="TextBlockAlign.CENTER"
    ></hdi-text-block>
    <ng-container *ngIf="welcomeContent?.search?.hasSearch">
      <hdi-inpage-search
        [placeholder]="welcomeContent?.search?.placeholder ?? ''"
        [searchGroup]="[]"
      ></hdi-inpage-search>
    </ng-container>
  </hdi-section>
</ng-container>

<!-- News Component -->
<ng-container *ngIf="newsComponent">
  <hdi-section>
    <hdi-filter-bar
      [news]="news"
      [caasFilters]="newsFilters"
      (filteredNews)="onFilteredNews($event)"
      [attr.data-preview-id]="newsComponent.identifier"
    ></hdi-filter-bar>
  </hdi-section>
  <hdi-section [backgroundColor]="'grey'">
    <hdi-dynamic-teaser-showcase
      [news]="filteredNews.length > 0 ? filteredNews : news"
      [imagesMetaData]="imagesMetaData"
    ></hdi-dynamic-teaser-showcase>
  </hdi-section>
</ng-container>

<!-- Inpage Navigation -->
<ng-container *ngIf="inpageNav && inpageMenu.length">
  <hdi-inpage-navigation
    [caasData]="inpageNav"
    [CTAButton]="true"
    [inpageMenu]="inpageMenu"
  ></hdi-inpage-navigation>
</ng-container>
